module.exports = __webpack_public_path__ + "img/5.a29d7aed.png";